<template>
  <div class="mb-20">
    <div class="media">
      <div class="media-left mr-10">
        <avatar
          :username="getCommercial.prenom + ' ' + getCommercial.nom"
          :size="40"
          background-color="#333B53"
          color="white"/>
      </div>
      <div class="media-content">
        <label class="has-text-weight-bold has-text-grid-1 is-size-14px">
          {{getCommercial.prenom + ' ' + getCommercial.nom.toUpperCase()}}
        </label>
        <p class="is-size-7 has-text-grid-1 has-text-default">
          {{profil}}
          <strong class="has-text-default"> {{getSociete.libelle}} </strong>
        </p>
      </div>
    </div>
    <div class="block-info-commercial is-size-14px pa-10 mt-10">
      <p>Une question ?</p>
      <div v-if="getCommercial.telephone">
        <p> Contactez-moi au
          <span class="has-text-weight-bold underline">{{getCommercial.telephone}}</span> <br>
          ou par email
          <a
            :href="`mailto:${getCommercial.email}`"
            class="has-text-weight-bold has-text-white underline">
            {{getCommercial.email}}
          </a>
        </p>
      </div>
      <div v-else>
        <p>Contactez moi par mail
          <a :href="`mailto:${getCommercial.email}`"
             class="has-text-weight-bold has-text-white underline">
            {{getCommercial.email}}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Avatar from 'vue-avatar'

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    Avatar,
  },
  computed: {
    ...Recommandation.mapGetters({
      getCommercial: 'commercial',
      getSociete: 'societe',
    }),
    panneaux() {
      return this.Recom.data.pointDeVentes[0].panneaux;
    },
    profil() {
      if (this.getCommercial.profil === 'Commercial') return 'Responsable de clientèle';
      if (this.getCommercial.profil === 'DirecteurCommercial') return 'Directeur Clientèle';
      if (!this.getCommercial.profil) return '';
      return this.getCommercial.profil.replace(/([a-z])([A-Z])/g, '$1 $2');
    }
  },
}
</script>

<style>

</style>